export interface PaymentParams {
  checkoutSessionId: string;
  confirmationRedirectUrl: string;
  clientSecret: string;
  paymentMethod: string;
  currency: string;
  amount: number;
  status?: string;
  directPayment: boolean;
}

export interface WebcallSummary {
  webcallUsed: number;
  webcallUsedToday: number;
  webcallLimit: number;
}

export interface Balance {
  monetary: number;
  voice: number;
}

export interface ActiveCard {
  brand: string;
  cardExpired: boolean;
  expMonth: number;
  expYear: number;
  last4Digits: string;
}

export interface User {
  administrative?: boolean;
  avatarUrl?: string;
  companyName?: string;
  domain?: string;
  language?: string;
  name?: string;
  permissions?: string[];
  role?: string;
  shouldForcePayment?: boolean;
  surname?: string;
  username?: string;
  clientType?: ClientType;
}

export interface SubscriptionParams {
  cancelAtPeriodEnd: boolean;
  destinationCountriesCount: number;
  discountDollars: number;
  discountPercentage: number;
  oldSubscriptionVoiceBalance: number;
  periodEnd: number;
  periodStart: number;
  plan: string;
  planId: string;
  planPrice: number;
  quantity: number;
  subscriptionPrice: number;
  trial: boolean;
  type: string;
  voiceBalanceSeconds: number;
}

export enum InboundHandlingStrategyType {
  BROADCAST = 'BROADCAST',
  LONGEST_IDLE = 'LONGEST_IDLE',
  RANDOM_CASCADE = 'RANDOM_CASCADE'
}

export interface AccountLimits {
  campaignLimit?: number;
  reportsBackwardDays?: number;
  recordingsStorageDays?: number;
  inboundQueueLimit?: number;
  integrationsLimit?: number;
  ivrLimit?: number;
  webhooksLimit?: number;
  tollFreeNumbersLimit?: number;
  callsHistoryLimit?: number;
  didsLimit?: number;
  userLimit?: number;
  availableInboundStrategies?: InboundHandlingStrategyType[];
}

export enum ClientType {
  CRAZYCALL = 'CRAZYCALL',
  AYA_MOBILE = 'AYA_MOBILE',
  CHANNELS = 'CHANNELS',
  SHOPER_CONNECT = 'SHOPER_CONNECT'
}
